<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true" ref="filters" :model="filters">
                    <el-form-item label="接口名称" prop="name">
                        <el-input placeholder="名称" style="min-width: 120px" v-model="filters.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search()">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('filters')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="pros" highlight-current-row v-loading="loading" style="width: 100%">
                <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="IP" prop="ip"></el-table-column>
                <el-table-column label="接口名称" prop="name"></el-table-column>
                <el-table-column prop="url" label="接口地址" min-width="100">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top">
                            <p>{{ scope.row.url }}</p>
                            <div slot="reference" class="name-wrapper">
                                <el-tag type="warning">{{
                                    scope.row.url.substring(0, 50) +
                                    "..." 
                                }}</el-tag>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="请求方式" prop="type"></el-table-column>
                <el-table-column label="请求耗时" prop="elapsedtime">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.elapsedtime < 3000 ? 'primary' : 'success'" disable-transitions>{{
                            scope.row.elapsedtime
                        }} ms</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="用户姓名" prop="username"></el-table-column>
                <el-table-column label="是否鉴权" prop="authtype"></el-table-column>
                <el-table-column prop="param" label="请求参数" width="100">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top">
                            <p>{{ scope.row.param }}</p>
                            <div slot="reference" class="name-wrapper">
                                <el-tag type="info">{{
                                    scope.row.param.substring(0, 10) +
                                    "..." 
                                }}</el-tag>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="operationtime" width="180" :formatter="formatTime"></el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[10, 20, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-col>
        </el-col>
    </el-row>
</template>
<script>

import Api from "../../../api/frbasicapi/log"
import moment from 'moment'
export default {
    data() {
        return {
            filters: {
                name: ""
            },
            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            pros: [],
        };

    },
    methods: {
        resetForm(formName) {
            this.$nextTick(() => {
                this.$refs[formName].resetFields();
            });
        },
        indexMethod(index) {
            return (index + 1) + (this.page - 1) * (this.limit)
        },
        //时间格式转化
        dateFormat(dateData) {
            var date = new Date(dateData);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var H = date.getHours();
            H = H < 10 ? "0" + H : H;
            var ms = date.getMinutes()
            ms = ms < 10 ? "0" + ms : ms;
            var s = date.getMilliseconds()
            s = s < 10 ? "0" + s : s;
            const time = y + "-" + m + "-" + d + " " + H + ":" + ms + ":" + s;
            return time;
        },
        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {
            let params = {
                pageNum: this.page,
                pageSize: this.limit,
                name: this.filters.name,
            };

            this.loading = true

            let that = this
            Api.apiList(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.pros = result.data.content;
                        } else {
                            that.total = 0;
                            that.pros = null;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },
    },

    mounted() {
        this.handleSearch()
    },
};
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
